import axios from 'axios';

export const quoterApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/quoter`,
    headers: {
        'Content-Type': 'application/json'
    }
})